import { ClientError, gql, request } from "graphql-request";
import { contentfulConfig } from "./configuration";
import { useSWRCurried } from "./fetching";

interface IncidentMessage {
  sys: {
    id: string;
    publishedAt: string;
  };
  description: { json: any };
}

interface IncidentMessageCollection {
  incidentMessageCollection: {
    total: number;
    items: IncidentMessage[];
  };
}

const incidentMessageFetcher = async (_: string): Promise<IncidentMessageCollection> => {
  return request<IncidentMessageCollection>(
    contentfulConfig.graphqlEndpoint,
    gql`
      query IncidentMessage {
        incidentMessageCollection(limit: 1, order: sys_publishedAt_DESC) {
          total
          items {
            sys {
              id
              publishedAt
            }
            description {
              json
            }
          }
        }
      }
    `,
  );
};

export function useIncidentMessage() {
  const { data, error } = useSWRCurried<ClientError>()("contentful/incident-message", incidentMessageFetcher);

  const activeIncident = data?.incidentMessageCollection.items[0];
  const publishedDate = activeIncident ? new Date(activeIncident.sys.publishedAt).toLocaleDateString("da-DK") : undefined;

  return {
    publishedDate,
    incidentMessage: activeIncident?.description.json,
    incidentMessageFetchError: error,
    isLoadingIncidentMessage: !data && !error,
  };
}
